export default __webpack_public_path__ + "static/media/antoniam.df5868ce.mp4";